import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/blog/")({
  head: () => buildHead({
    title: "Blog OP2P | CRM inteligente, Agentes de IA e gestão comercial",
    description: "Guias práticos sobre CRM inteligente, sistemas multiagentes de IA, gestão comercial, atendimento e automação no WhatsApp e Instagram para empresas.",
    path: "/blog",
  }),
  component: Blog,
});
